module.exports = __webpack_public_path__ + "02_face.e223ccb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer1/02_face.png
// module id = DmEA
// module chunks = 0